<template>
  <v-container
    class="text--secondary w-80"
  >
    <div
      class="text-h4 text-center"
    >
      Got it. Let's get some more info about your products.
    </div>
    <v-data-iterator
      :items="getProducts"
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:default="props">
        <v-container>
          <ProductFormStarter
            v-for="item in props.items"
            :key="item.product_id"
            :product="item"
          />
        </v-container>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProductFormStarter from '@/components/mainframes/ProductFormStarter.vue';

export default {
  name: 'ProductsFrame',
  computed: {
    ...mapGetters(['getProducts', 'getFormData']),
    ...mapActions(['setMainTab']),
  },
  methods: {
    getFormStatusDescription(formStatus) {
      return this.formStatuses[formStatus || 'not_started'];
    },
  },
  components: {
    ProductFormStarter,
  },
};
</script>

<style scoped>
.w-80 {
  width: 80%;
}
</style>
